import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { date, RxFormBuilder, RxFormGroup, suffix } from '@rxweb/reactive-form-validators';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Template } from 'src/app/modules/templates/_types/template';
import { TemplatesService } from 'src/app/modules/templates/_services/templates.service';
import { Filter, FilterOperation, OrFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { Editor } from 'tinymce';
import { MailMessage } from '../_types/mail-message';
import { MailMessageService } from '../_services/mail-messages.service';
import { MailAccountsService } from '../_services/mail-account.service'; 
import { MailMessageRecipient, MailRecipientType } from '../_types/mail-message-receipt';
import { MailMessageRecipientService } from '../_services/mail-messages-recipients.service';
import { SMSMessageService } from '../_services/sms-messages.service';
import { SMSMessage, SMSMessageState } from '../_types/sms-message';
import { MailMessageAttachmentService } from '../_services/mail-messages-attachments.service';
import { MailMessageAttachment } from '../_types/mail-message-attachment';
import { FilesService } from '../../common/_services/files.service';
import { CasesExpertsService } from '../../cases/_services/cases-experts.service';
import { CaseService } from '../../cases/_types/case-service';
import { AffectedsService } from '../../cases/_services/affecteds.service';
import { CasesService } from '../../cases/_services/cases.service';
import { CaseExpert } from '../../cases/_types/case-expert';
import { CasesServicesService } from '../../cases/_services/cases-services.service';
import { Affected } from '../../cases/_types/affected';
import { WhatsappMessage, WhatsappMessageState } from '../_types/whatsapp-message';
import { WhatsappMessageService } from '../_services/whatsapp-messages.service';
import { PanelMenu } from 'primeng/panelmenu';
import { ThisReceiver } from '@angular/compiler';
import { ContractOutgoingMail, ContractsOutgoingMailResourceType } from '../../companies/_types/contract-outgoing-mail';
import { ContractOutgoingMailsService } from '../../companies/_services/contracts-outgoing-mails.service';
import { Case } from '../../cases/_types/case';

@Component({
    selector: 'app-comunications',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './comunications.component.html',
    styleUrls: ['./comunications.component.css'],
    standalone: false
})
export class ComunicationsComponent implements OnInit {
  
  @ViewChild('tos') public tos!: PanelMenu;

  private outgoingMailResourceType:ContractsOutgoingMailResourceType = ContractsOutgoingMailResourceType.Other;
  public comunicationType: string = "";
  public template_id!: string;
  public mailFormGroup!: RxFormGroup;
  public smsFormGroup!: RxFormGroup;
  public whatsappFormGroup!: RxFormGroup;
  public mailMessage: MailMessage = new MailMessage();
  public smsMessage: SMSMessage = new SMSMessage();
  public whatsappMessage: WhatsappMessage = new WhatsappMessage();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public comunicationTypes: any = [{name: "Email", code:"Mail" },{name: "SMS", code:"SMS" },{name: "Whatsapp", code:"Whatsapp" }];
  public templates: Template[] = [];
  public type: string="mail";
  public showComunicationType: boolean = true;
  public model : any;
  public attachments: any[] = [];
  public selectedAttachments: any[] = [];
  public thirdpartySelector: boolean = false;
  public maxSmsMessagesLength: number = 300;

  //aviso cuando se pide preseleccionar una plantilla por código y no está disponible
  public templateWarning: string = "";

  //la carga de plantillas del constructor, para poder esperarla antes de preseleccionar
  private templatesLoaded?: Promise<void>;

  //Para poder seleccionar informacion relacionada con el caso para añadir emais.
  public caseId: string = "";
  public case?: Case;
  public thirdPartiesSendEmail:any= {};
  public thirdParties: any[] = [];
  public thirdPartiesExpert: any[] = [];
  public caseExperts: CaseExpert[] = [];
  public affecteds: Affected[] = [];
  public tosActions: any[] = [];
  public mail_accounts: any[] = [];
  public thirdPartyOptions : any = [];
  public templateDestination: string;
  public transaction : any;

  init: EditorComponent['init'] = {
    promotion: false,
    content_css: '/assets/tinymce/content.css',
    plugins: 'lists link image table code', //variables
    custom_elements: 'variable',
    extended_valid_elements: 'span[variable]',
    toolbar: 'undo redo | formatselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | link image table | code | variables-menu',
    /*external_plugins: {
      variables: '/assets/tinymce/variables-plugin.js'
    },*/
    variable_mapper: {
      Code: 'Código',
      Date: 'Fecha',
      TaxAmount: 'IVA',
      Subtotal: 'Subtotal',
      Total: 'Total'
    },
    setup: (ed:Editor) => {
      ed.on('variableClick', (e:any) => {
         console.log('click', e);
      });
    },
  };


  constructor( 
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private templatesService: TemplatesService,
    private smsMessageService: SMSMessageService,
    private whatsappMessageService: WhatsappMessageService,
    private mailMessageService: MailMessageService, 
    private mailMessageRecipientService: MailMessageRecipientService, 
    private mailMessageAttachmentService: MailMessageAttachmentService,
    private mailAccountService: MailAccountsService, 
    private filesService: FilesService, 
    private caseService: CasesService,
    private casesExpertsService: CasesExpertsService,
    private caseAfectedService: AffectedsService,
    private casesServicesService: CasesServicesService,
    private contractOutgoingMailsService: ContractOutgoingMailsService
) { 
    this.templateDestination = this.config.data.templateDestination;

    //si hay tipo de comunicación lo establecemos
    if(this.config.data.outgoingMailResourceType != null){
      this.outgoingMailResourceType = this.config.data.outgoingMailResourceType;
    }

    //si hay un email, lo añadimos como destinatario
    if(this.config.data.email != null){
      this.mailMessage.tos = this.config.data.email;
    }

    //si hay caseId lo establecemos
    if(this.config.data.caseId != null){
      this.mailMessage.caseId = this.config.data.caseId;
      this.smsMessage.caseId = this.config.data.caseId;
      this.caseId = this.config.data.caseId;
    }

    //si hemos recibido un modo de comunicación, lo establecemos
    if(this.config.data.comunicationType != null){
      this.comunicationType = this.config.data.comunicationType;
      this.templatesLoaded = this.changeComunicationType({value: this.comunicationType});
    }

    //si hemos recibido un phonenumber lo establecemos
    if(this.config.data.phoneNumber != null){
      this.smsMessage.phoneNumber = this.config.data.phoneNumber;
      this.whatsappMessage.phoneNumber = this.config.data.phoneNumber;
    }

    //Si hemos recibido el subject
    if(this.config.data.subject != null){
      this.mailMessage.subject = this.config.data.subject;
    }
    /*if(this.config.data.thirdpartySelector != null){
      this.thirdpartySelector = this.config.data.thirdpartySelector;
    }*/
    //si hemos recibido attachments los añadimos
    if(this.config.data.attachments != null){
      var filesids =  this.config.data.attachments;
      filesids.forEach(async (item: any) => {
        var f = await firstValueFrom(this.filesService.get(item));
        this.attachments.push(f);
      });
    }

    if(this.config.data.transaction != null){
      this.transaction = this.config.data.transaction;
    }
  }
  
  async ngOnInit() {   

    this.allowWrite = true; //this.loginService.hasPermission("PROVIDERS_WRITE");
    this.allowDelete = true;     
    this.mailMessage.caseId = (this.config.data.caseId ?? this.config.data.caseId);
    this.mailMessage.type_comunication = this.config.data.type_comunication;

    if(this.mailMessage.type_comunication != "" && this.mailMessage.type_comunication != null) this.showComunicationType = false;
    this.model = this.config.data.model;

    //obtenemos el id del mail account para enviar.  
    let filters = {
      IsSystem: new Filter(FilterOperation.equals, 'isSystem', "", true)
    };
    let params: IParamsCollection = {
      page: { size: 200 },
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    }

    let response = await firstValueFrom(this.mailAccountService.all(params));
    this.mail_accounts = response.data;
    //this.mailMessage.mailAccountId = response.data[0].id;

    this.mailFormGroup = this.formBuilder.formGroup<MailMessage>(this.mailMessage) as RxFormGroup;  
    this.smsFormGroup = this.formBuilder.formGroup<SMSMessage>(this.smsMessage) as RxFormGroup;   
    this.whatsappFormGroup = this.formBuilder.formGroup<WhatsappMessage>(this.whatsappMessage) as RxFormGroup;   

    if(this.caseId!=''){
      await this.loadCaseData();
      await this.loadContractOutgoingMails();
      await this.loadDataMailsAvailables();
    }

    //la preselección va aquí y no en el constructor porque changeTemplate rellena los formGroups
    if(this.config.data.templateCode != null){
      await this.preselectTemplate(this.config.data.templateCode);
    }

  }

  /// Preselecciona la plantilla con el código indicado. Se busca entre las plantillas ya cargadas para
  /// el tipo de comunicación elegido, de forma que si la plantilla existe pero no aplica a ese tipo o
  /// destino tampoco se selecciona: quedaría marcada una opción que no está en el desplegable.
  async preselectTemplate(templateCode: string){
    await this.templatesLoaded;

    let template = this.templates.find(m => m.code == templateCode);
    if(template == null){
      this.templateWarning = this.config.data.templateMissingWarning ?? "No se ha encontrado la plantilla predeterminada para esta comunicación. Redacte el mensaje manualmente.";
      return;
    }

    this.template_id = template.id!;
    await this.changeTemplate({ value: template.id });
  }

  async loadCaseData(){
    this.case = await firstValueFrom(this.caseService.get(this.caseId, { include: ['company'] }));
  }

  async loadContractOutgoingMails(){
    let filters = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.case?.contractId)
    };
    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    }

    let response = await firstValueFrom(this.contractOutgoingMailsService.all(params));

    //dejamos solo los mailsaccount que tiene el contrato
    this.mail_accounts = this.mail_accounts.filter((m: any) => response.data.some((c: ContractOutgoingMail) => c.mailAccountId == m.id));
    
    //si tiene cuenta de salida para otros mails, la marcamos por defecto
    if(response.data.length > 0){
      let outgoingMail = response.data.find((m: ContractOutgoingMail) => m.outgoingMailResourceType == this.outgoingMailResourceType);
      if(outgoingMail != null){
        this.mailMessage.mailAccountId = outgoingMail.mailAccountId;
        this.mailFormGroup.patchValue({ mailAccountId: outgoingMail.mailAccountId });
      }
    }
  }

  async loadDataMailsAvailables(){

    if(this.case == null) return;

    //Cargo la compañia
    var aux: { label: string;   items: { label: string; email:string; command: (event: any) => void }[] } = {
      label: 'Compañia',
      items: []
    };
    
    aux.items.push({
      label: this.case?.company.name,
      email: this.case?.company.email,
      command: (event: any) => {
        this.mailFormGroup.patchValue({ tos: this.case?.company.email });
      }
    });
    this.thirdPartyOptions.push(aux);

    //Cargamos los peritos
    await this.loadCaseExperts();
    if(this.caseExperts.length > 0){
      aux = {
        label: 'Perito',
        items: []
      };

      this.caseExperts.forEach((item: CaseExpert) => {
        aux.items.push({
          label: item.expert?.name,
          email: item.expert?.email,
          command: (event: any) => {
            this.mailFormGroup.patchValue({ tos: item.expert?.email });
          }
        });
      });
      this.thirdPartyOptions.push(aux);
     }

     //Cargamos los trabajadores
     await this.loadServices();
     if(this.thirdParties.length > 0){
      aux = {
        label: 'Trabajadores',
        items: []
      };

      this.thirdParties.forEach((item: any) => {
        aux.items.push({
          label: item.name ?? item.email ?? "",
          email: item.email,
          command: (event: any) => {
            this.mailFormGroup.patchValue({ tos: item.email });
          }
        });
      });
      this.thirdPartyOptions.push(aux);
     }

      
      await this.loadAffecteds();
      if(this.affecteds.length > 0){
        aux = {
          label: 'Afectados',
          items: []
        };
  
        this.affecteds.forEach((item: Affected) => {
          aux.items.push({
            label: item.name + "(" + item.email + ")",
            email: item.email,
            command: (event: any) => {
              this.mailFormGroup.patchValue({ tos: item.email });
            }
          });
        });
        this.thirdPartyOptions.push(aux);
      }
      
  }

  replaceValues(html: any){
    //Sustituir variables.
    if(this.transaction != null){
      var spanVariableRegex = new RegExp('<span variable="(.*?)">(.*?)<\/span>', 'g');
      var matches = html.match(spanVariableRegex);
      if(matches){
        matches.forEach((match:any) => {
            var variable = match.match(/variable="(.*?)"/)[1];
            variable = variable.substr(0,1).toLowerCase()+variable.substr(1);
            if(this.transaction!=null && this.transaction[variable] != null){                         
              html = html.replace(match, this.transaction[variable]);
            }
        });
      }               
    }
    return html;
  }

  async changeTemplate(event: any){
    if(event != null && event.value !=null){
      let infoTemplate = this.templates.filter(m => m.id == event.value)[0];      
      //let caseData = await firstValueFrom(this.caseService.get(this.caseId, { include: ['company'] }));

      this.templatesService.parseHtml(event.value, this.model).subscribe({
        next: (data: any) => {
          
          //Si tienen transacción miramos para sustituir variables.
          data.html = this.replaceValues(data.html);

          //console.log(data);

          if(this.comunicationType == "Mail"){
            this.mailFormGroup.patchValue({ subject: data.subject ?? infoTemplate.subject, content: data.html });
          }else if(this.comunicationType == "SMS"){
            this.smsFormGroup.patchValue({ content: data.html });
          }else if(this.comunicationType == "Whatsapp"){
            this.whatsappFormGroup.patchValue({ content: data.html });
          }
        },
        error: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });      
    }
  }

  async changeComunicationType(event: any){
    if(event.value == "Mail" || event.value == "SMS" || event.value == "Whatsapp"){
      let type = "Email";
      if(event.value != "Mail") type=event.value;
      let filters = {
        templateType: new Filter(FilterOperation.equals, 'templateType', "", type),
        templateDestinationType: new OrFilter([
                new Filter(FilterOperation.equals, 'templateDestinationType', '', this.templateDestination),
                new Filter(FilterOperation.equals, 'templateDestinationType', '', null, true)
              ]),        
      };          

      let params: IParamsCollection = {
        sort: ['name'],
        filter: FilterBuilder.fromObject(filters).build()
      }
      //cargamos las plantillas 
      let response = await firstValueFrom(this.templatesService.all(params));
      this.templates = response.data;
    }
  }

  async saveMail() {

    let valid = this.formValidationService.validateForm(this.mailFormGroup);
    if (valid) {

      
      this.mailMessage = Object.assign(this.mailMessage, this.mailFormGroup.value);
      delete this.mailMessage.id;
      this.mailMessage.to = this.mailMessage.tos?.split(",");
      this.mailMessage.bcc = this.mailMessage.bccs?.split(","); 
      this.mailMessage.cc = this.mailMessage.ccs?.split(",");
      
      let attachmentsToSend: MailMessageAttachment[] = [];
      this.attachments.forEach((item: any) => {
        var att = new MailMessageAttachment()
        delete att.id;
        att.fileId = item.id;
        attachmentsToSend.push(att);
      });

      let recipients:MailMessageRecipient[] = [];
      this.mailMessage.to?.forEach((item: any) => {
        var m = new MailMessageRecipient();
        delete m.id;
        m.mailAddress = item;
        m.recipientType = 0;
        recipients.push(m);
      });        

      //guardamos los TOs y BCC
      this.mailMessage.bcc?.forEach((item: any) => {
        var m = new MailMessageRecipient();
        delete m.id;
        m.mailAddress = item;
        m.recipientType = 1;
        recipients.push(m);
      });  
      
        //guardamos los TOs y BCC
      this.mailMessage.cc?.forEach((item: any) => {
        var m = new MailMessageRecipient();
        delete m.id;
        m.mailAddress = item;        
        m.recipientType = 2;
        recipients.push(m);
      });
      this.mailMessage.attachments = attachmentsToSend;
      this.mailMessage.recipients = recipients;
      var fullMailMessage = {
        MailMessage: this.mailMessage,
        //MailMessageAttachments: attachmentsToSend,
        //MailMessageRecipients: recipients
      }

      var response = await firstValueFrom(this.mailMessageService.MailMessageSend(fullMailMessage)).then((data: any) => {
        if(data.success){
          this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Comunicación enviada correctamente." });
          this.dynamicDialogRef.close(this.mailMessage ? null : this.mailMessage);
        }else{
          this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Error al enviar el email: " + data.error });  
        }

        
      })
      .catch((error: any) => {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Error al enviar el email: " + error.error.title });
      });

      /*
      //Ahora creamos la comunicación
      this.mailMessage = Object.assign(this.mailMessage, this.mailFormGroup.value);
      delete this.mailMessage.id;
      this.mailMessage.to = this.mailMessage.tos?.split(",");
      this.mailMessage.bcc = this.mailMessage.bccs?.split(","); 
      this.mailMessage.cc = this.mailMessage.ccs?.split(",");
      
      //creamos mensaje
      let mailSended: any =await firstValueFrom(this.mailMessageService.save(this.mailMessage));
      

      //creamos los adjuntos 
      let attachmentsToSend: MailMessageAttachment[] = [];
      this.attachments.forEach((item: any) => {
        var att = new MailMessageAttachment()
        att.mailMessageId = mailSended.id;
        att.fileId = item.id;
        attachmentsToSend.push(att);
      });

      attachmentsToSend.forEach(async (att: any) => {
        await firstValueFrom(this.mailMessageAttachmentService.save(att));
      });

      //preparamos los destinatarios
      let recipients:MailMessageRecipient[] = [];
      this.mailMessage.to?.forEach((item: any) => {
        var m = new MailMessageRecipient();
        m.mailAddress = item;
        m.mailMessageId = mailSended.id;
        m.recipientType = 0;
        recipients.push(m);
      });        

      //guardamos los TOs y BCC
      this.mailMessage.bcc?.forEach((item: any) => {
        var m = new MailMessageRecipient();
        m.mailAddress = item;
        m.mailMessageId = mailSended.id;
        m.recipientType = 1;
        recipients.push(m);
      });  
      
        //guardamos los TOs y BCC
      this.mailMessage.cc?.forEach((item: any) => {
        var m = new MailMessageRecipient();
        m.mailAddress = item;
        m.mailMessageId = mailSended.id;
        m.recipientType = 2;
        recipients.push(m);
      });

      //guardamos los destinatarios
      recipients.forEach(async (recipient: MailMessageRecipient) => {
        await firstValueFrom(this.mailMessageRecipientService.save(recipient));
      });
      
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Comunicación guardada correctamente." });
      this.dynamicDialogRef.close(this.mailMessage ? null : this.mailMessage);
      */

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async saveSMS() {
    let valid = this.formValidationService.validateForm(this.smsFormGroup);
    if (valid) {
      delete this.smsMessage.id;
      this.smsMessage = await firstValueFrom(this.smsMessageService.Send(this.smsMessage));
      if(this.smsMessage.state == SMSMessageState.Sent){
        this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "SMS enviado correctamente." });
        this.dynamicDialogRef.close(this.smsMessage ? null : this.smsMessage);
      }else{
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Error al enviar el SMS: " + this.smsMessage.stateInfo });
      }
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }


  async saveWhatsapp() {
    let valid = this.formValidationService.validateForm(this.whatsappFormGroup);
    if (valid) {
      delete this.whatsappMessage.id;

      //obtenemos plantilla
      let template = this.templates.find(m => m.id == this.template_id);
      if(template!=null){
        this.whatsappMessage.templateId = template.id;
        this.whatsappMessage.contentSid = template.contentSID;
      }
      
      this.whatsappMessage = await firstValueFrom(this.whatsappMessageService.Send(this.whatsappMessage));
      if(this.whatsappMessage.state == WhatsappMessageState.Sent){
        this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Whatsapp enviado correctamente." });
        this.dynamicDialogRef.close(this.whatsappMessage ? null : this.whatsappMessage);
      }else{
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Error al enviar el Whatsapp: " + this.whatsappMessage.stateInfo });
      }
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  getImage(mimetype: string) {
    var ret = "pi pi-file-pdf";
    if (mimetype == "application/pdf") {
      ret = "pi pi-file-pdf";
    } else if (mimetype == "image/png" || mimetype == "image/jpeg" || mimetype == "image/jpg" || mimetype == "image/gif" || mimetype == "image/bmp") {
      ret = "pi pi-image";
    } else if (mimetype == "application/msword" || mimetype == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      ret = "pi pi-file-word";
    } else if (mimetype == "application/vnd.ms-excel" || mimetype == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      ret = "pi pi-file-excel";
    } else if (mimetype == "application/vnd.ms-powerpoint" || mimetype == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
      ret = "pi pi-file-excel";
    }
    return ret;
  }


  
  async changeThirdParty(event: any){
    if(event.value == "company"){

      let caseData = await firstValueFrom(this.caseService.get(this.caseId, { include: ['company'] }));

      this.mailFormGroup.patchValue({ tos: caseData.company.email });
      
    }else if(event.value=="caseExpert"){
      await this.loadCaseExperts();
     

    }else if(event.value=="worker"){
      await this.loadServices();
      

    }else if(event.value="affected"){
      await this.loadAffecteds();

    }

  }
  async selectThirdParty(event: any)
  {
    this.mailFormGroup.patchValue({ tos: event.value });
  }
  
  
  async loadCaseExperts() {
    let params: IParamsCollection = {
      include: ['expert']
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId", "", this.caseId),
    };
    params.filter = FilterBuilder.fromObject(filters).build();
  
    let response = await firstValueFrom(this.casesExpertsService.all(params));
    this.caseExperts = response.data.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
  }

  async loadServices() {
    let params: IParamsCollection = {
      sort: ['date']
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
    };

    filters.caseId.value = this.caseId;
    params.filter = FilterBuilder.fromObject(filters).build();
    params.include = ['worker', 'capability', 'cancelCaseServiceReason'];

    let response = await firstValueFrom(this.casesServicesService.all(params));
   
    this.thirdParties = response.data.map((service: CaseService) => {
      return {
        email: service.worker?.email,
        name: service.worker?.name
      }
    }).filter((v, i, a) => a.findIndex(t => (t.email === v.email)) === i);
  }

  async loadAffecteds() {
    let params: IParamsCollection = {
      include: ['address']
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId", "", this.caseId),
    };
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.caseAfectedService.all(params));
    this.affecteds = response.data;    
  }

  addEmails(where: string, email  : string)
  {
    if(where == "tos"){
      var mailsexisted = this.mailFormGroup.get('tos')?.value;
      if(mailsexisted != null && mailsexisted != ""){
        mailsexisted = mailsexisted + "," + email;
      }else { mailsexisted = email;}
      this.mailFormGroup.patchValue({ tos: mailsexisted })
    }else if(where == "ccs"){
      
      var mailsexisted = this.mailFormGroup.get('ccs')?.value;
      if(mailsexisted != null && mailsexisted != ""){
        mailsexisted = mailsexisted + "," + email;
      }else { mailsexisted = email;}
      this.mailFormGroup.patchValue({ ccs: mailsexisted })

    }else if(where == "bccs"){
      
      var mailsexisted = this.mailFormGroup.get('bccs')?.value;
      if(mailsexisted != null && mailsexisted != ""){
        mailsexisted = mailsexisted + "," + email;
      }else { mailsexisted = email;}
      this.mailFormGroup.patchValue({ bccs: mailsexisted })

    }
  }

}
